import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import React from "react";

export interface TakePhotoDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
}

function TakePhotoDetails({
  name,
  handleTaskItemNameChange,
}: TakePhotoDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
  ];
  return (
    <ConfigForm title="Configure Take Photo Input" inputs={inputs}></ConfigForm>
  );
}

export default TakePhotoDetails;
